<div class="page-container" style="min-height:188.38330078125px">
  <div class="page-content">
    <!--<div class="panel panel-flat shadow" style="border: none">
      <div class="panel-body">-->
        <div class="panel panel-flat shadow" style="border: none">
          <div class="panel-body">
            <div class="row">
              <table class="table table-sm table-xs table-condensed table-borderless">
                <thead></thead>
                <tbody>
                  <tr>
                    <th class="col-sm-2 col-xs-3" style="text-align: right" translate>Service Plan</th>
                    <td class="col-sm-6 col-xs-6">{{translate.instant(authorization?.userAccount?.subscription?.plan?.name)}}</td>
                    <td class="col-sm-2 col-xs-1 text-right">
                      <button *ngIf="isTeamMember == false" class="btn btn-xs btn-with btn-primary" type="button" (click)="showUpgradePlans()" translate>Upgrade</button>
                    </td>
                    <td class="col-sm-2 col-xs-1 text-left">
                      <button *ngIf="isTeamMember == false" class="btn btn-xs btn-with btn-primary" type="button" (click)="showSubscriptionInfo()" translate>Subscription Info</button>
                    </td>
                  </tr>
                  <tr>
                    <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Used Storage</th>
                    <td class="col-sm-6 col-xs-6">{{authorization?.userAccount?.subscription?.usedStorage}} MB<ng-container *ngIf="(authorization?.userAccount?.subscription?.plan?.quota + authorization?.userAccount?.subscription?.extraStorage) > 0"> / {{authorization?.userAccount?.subscription?.plan?.quota + authorization?.userAccount?.subscription?.extraStorage}} MB</ng-container></td>
                    <td class="col-sm-3 col-xs-3"></td>
                  </tr>
                  <tr>
                    <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Monthly Signature</th>
                    <td class="col-sm-6 col-xs-6">{{authorization?.userAccount?.subscription?.monthlySignature}}<ng-container *ngIf="(authorization?.userAccount?.subscription?.plan?.signatureMonthly + authorization?.userAccount?.subscription?.extraSignature) > 0"> / {{authorization?.userAccount?.subscription?.plan?.signatureMonthly + authorization?.userAccount?.subscription?.extraSignature}}</ng-container></td>
                    <td class="col-sm-3 col-xs-3"></td>
                  </tr>
                  <tr>
                    <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Total Signature</th>
                    <td class="col-sm-6 col-xs-6">{{authorization?.userAccount?.subscription?.totalSignature + authorization?.userAccount?.subscription?.monthlySignature}}</td>
                    <td class="col-sm-3 col-xs-3"></td>
                  </tr>
                  <tr>
                    <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Username/Email</th>
                    <td class="col-sm-6 col-xs-6">{{authorization?.userProfile?.email}}</td>
                    <td class="col-sm-3 col-xs-3"></td>
                  </tr>
                  <tr>
                    <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Password</th>
                    <td class="col-sm-6 col-xs-6">**************</td>
                    <td class="col-sm-3 col-xs-3" style="float: right;">
                      <button class="btn btn-xs btn-with btn-primary" type="button" (click)="changePassword()" translate>Change</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="panel panel-default shadow" style="border: none">
          <div class="panel-heading">
            <h4 class="panel-title col-md-3 col-sm-3 col-xs-4" translate>Email Adresses</h4>
            <span class="text-semibold" translate>If you associate your email with your account, you'll see the signing requests that are sent to this address on your account</span>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1 col-xs-10">
                <button type="button" class="btn btn-xs btn-primary pull-right" style="margin-bottom: 10px" [ngClass]="{ 'disabled': false }" (click)="showAddEmailModal()"><i class="icon-plus3"></i><span translate>Add New Email</span></button>
                <table class="table table-md table-sm table-condensed table-borderless text-left">
                  <tbody>
                    <tr *ngFor="let accountEmail of theAccountEmails; let x = index">
                      <td class="col-md-3 col-sm-3 col-xs-3"></td>
                      <td class="col-md-6 col-sm-6 col-xs-6">
                        <span>{{accountEmail?.email}}</span>
                        <span *ngIf="accountEmail.isPrimary=='yes'" translate>&nbsp;(primary)</span>
                        <span *ngIf="accountEmail.status=='PENDING'" translate>&nbsp;(waiting for approval)</span>
                      </td>
                      <td class="col-md-3 col-sm-3 col-xs-3 text-left">
                        <button type="button" class="btn btn-default btn-xs" [ngClass]="{ 'disabled': accountEmail.isPrimary=='yes' }" (click)="showRemoveEmailAlert(accountEmail)"><i class="icon-trash"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="panel panel-default shadow" style="border: none">
          <div class="panel-heading">
            <h4 class="panel-title" translate>Profile information</h4>
            <span class="text-semibold text-italic" translate>(is used to quickly fill your information)</span>
          </div>
          <div class="panel-body">
            <div class="row">
              <table class="table table-sm table-xm table-condensed table-borderless">
                <thead></thead>
                <tbody>
                <tr>
                  <th class="col-sm-3 col-xs-3"></th>
                  <td class="col-sm-6 col-xs-6"><button type="button" class="btn btn-xs btn-primary" style="float: right;" (click)="showEditProfile()" translate>Edit Profile</button></td>
                  <td class="col-sm-3 col-xs-3"></td>
                </tr>
                <tr>
                  <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Name</th>
                  <td class="col-sm-6 col-xs-6">{{authorization?.userProfile?.user_metadata?.name}}</td>
                  <td class="col-sm-3 col-xs-3"></td>
                </tr>
                <tr>
                  <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Title</th>
                  <td class="col-sm-8 col-xs-7">{{authorization?.userProfile?.user_metadata?.title}}</td>
                  <td class="col-sm-3 col-xs-3"></td>
                </tr>
                <tr>
                  <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Company</th>
                  <td class="col-sm-8 col-xs-7">{{authorization?.userProfile?.user_metadata?.company}}</td>
                  <td class="col-sm-3 col-xs-3"></td>
                </tr>
                <tr>
                  <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Country</th>
                  <td class="col-sm-8 col-xs-7">{{showCountryName(authorization?.userProfile?.user_metadata?.country)}}</td>
                  <td class="col-sm-3 col-xs-3"></td>
                </tr>
                <tr>
                  <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Address</th>
                  <td class="col-sm-8 col-xs-7">{{authorization?.userProfile?.user_metadata?.address}}</td>
                  <td class="col-sm-3 col-xs-3"></td>
                </tr>
                <tr>
                  <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Language</th>
                  <td class="col-sm-8 col-xs-7">{{translate.instant(authorization?.userProfile?.user_metadata?.language)}}</td>
                  <td class="col-sm-3 col-xs-3"></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Notification Preferences -->
        <div *ngIf="authorization?.userAccount?.subscription?.plan?.notificationControl === 'Y' && preferencesLoaded"
             class="panel panel-default shadow" style="border: none"
             data-testid="notification-preferences-panel">
          <div class="panel-heading">
            <h4 class="panel-title" translate>Notification Preferences</h4>
            <span class="text-semibold text-italic" translate>(control which email notifications you receive)</span>
          </div>
          <div class="panel-body">
            <div class="row">
              <table class="table table-sm table-xm table-condensed table-borderless">
                <thead></thead>
                <tbody>
                  <!-- #1 You signed a document -->
                  <tr data-testid="pref-email-you-signed">
                    <th class="col-sm-1 col-xs-1" style="text-align: right; vertical-align: middle;">
                      <label class="switch">
                        <input type="checkbox" [(ngModel)]="preferences.emailYouSigned"
                               (ngModelChange)="onToggleChange()" name="emailYouSigned"/>
                        <span class="slider round"> </span>
                      </label>
                    </th>
                    <td class="col-sm-9 col-xs-9">
                      <strong translate>You signed a document</strong><br>
                      <small class="text-muted" translate>Email sent to you after you sign a document</small>
                    </td>
                  </tr>

                  <!-- #2 Signature added to your job -->
                  <tr data-testid="pref-email-signature-added-to-your-job">
                    <th class="col-sm-1 col-xs-1" style="text-align: right; vertical-align: middle;">
                      <label class="switch">
                        <input type="checkbox" [(ngModel)]="preferences.emailSignatureAddedToYourJob"
                               (ngModelChange)="onToggleChange()" name="emailSignatureAddedToYourJob"/>
                        <span class="slider round"> </span>
                      </label>
                    </th>
                    <td class="col-sm-9 col-xs-9">
                      <strong translate>Signature added to your job</strong><br>
                      <small class="text-muted" translate>Email sent when a recipient signs a document you sent</small>
                    </td>
                  </tr>

                  <!-- #3 Signature added to team member's job (Owner only) -->
                  <tr *ngIf="!isTeamMember" data-testid="pref-email-signature-added-team-job">
                    <th class="col-sm-1 col-xs-1" style="text-align: right; vertical-align: middle;">
                      <label class="switch">
                        <input type="checkbox" [(ngModel)]="preferences.emailSignatureAddedTeamJob"
                               (ngModelChange)="onToggleChange()" name="emailSignatureAddedTeamJob"/>
                        <span class="slider round"> </span>
                      </label>
                    </th>
                    <td class="col-sm-9 col-xs-9">
                      <strong translate>Signature added to team member's job</strong><br>
                      <small class="text-muted" translate>Email sent when a recipient signs a document your team member sent</small>
                    </td>
                  </tr>

                  <!-- #4 Signing/approval request received -->
                  <tr data-testid="pref-email-signature-request-received">
                    <th class="col-sm-1 col-xs-1" style="text-align: right; vertical-align: middle;">
                      <label class="switch">
                        <input type="checkbox" [(ngModel)]="preferences.emailSignatureRequestReceived"
                               (ngModelChange)="onToggleChange()" name="emailSignatureRequestReceived"/>
                        <span class="slider round"> </span>
                      </label>
                    </th>
                    <td class="col-sm-9 col-xs-9">
                      <strong translate>Signing request received</strong><br>
                      <small class="text-muted" translate>Email sent when someone requests your signature or approval</small>
                    </td>
                  </tr>

                  <!-- #5 Signing completed (your job) -->
                  <tr data-testid="pref-email-job-completed-you-sent">
                    <th class="col-sm-1 col-xs-1" style="text-align: right; vertical-align: middle;">
                      <label class="switch">
                        <input type="checkbox" [(ngModel)]="preferences.emailJobCompletedYouSent"
                               (ngModelChange)="onToggleChange()" name="emailJobCompletedYouSent"/>
                        <span class="slider round"> </span>
                      </label>
                    </th>
                    <td class="col-sm-9 col-xs-9">
                      <strong translate>Signing completed (your job)</strong><br>
                      <small class="text-muted" translate>Email sent when all signatures are collected on a document you sent</small>
                    </td>
                  </tr>

                  <!-- #6 Signing completed (team member's job, Owner only) -->
                  <tr *ngIf="!isTeamMember" data-testid="pref-email-job-completed-team-sent">
                    <th class="col-sm-1 col-xs-1" style="text-align: right; vertical-align: middle;">
                      <label class="switch">
                        <input type="checkbox" [(ngModel)]="preferences.emailJobCompletedTeamSent"
                               (ngModelChange)="onToggleChange()" name="emailJobCompletedTeamSent"/>
                        <span class="slider round"> </span>
                      </label>
                    </th>
                    <td class="col-sm-9 col-xs-9">
                      <strong translate>Signing completed (team member's job)</strong><br>
                      <small class="text-muted" translate>Email sent when all signatures are collected on a document your team member sent</small>
                    </td>
                  </tr>

                  <!-- #7 Successful SFTP transfer (your job) — SFTP users only -->
                  <tr *ngIf="authorization?.userAccount?.subscription?.plan?.isSftpUser === 'Y'"
                      data-testid="pref-email-sftp-transfer-your-job">
                    <th class="col-sm-1 col-xs-1" style="text-align: right; vertical-align: middle;">
                      <label class="switch">
                        <input type="checkbox" [(ngModel)]="preferences.emailSftpTransferYourJob"
                               (ngModelChange)="onToggleChange()" name="emailSftpTransferYourJob"/>
                        <span class="slider round"> </span>
                      </label>
                    </th>
                    <td class="col-sm-9 col-xs-9">
                      <strong translate>Successful SFTP transfer (your job)</strong><br>
                      <small class="text-muted" translate>Email sent when an SFTP transfer completes successfully for a document you sent</small>
                    </td>
                  </tr>

                  <!-- #8 Successful SFTP transfer (team member's job, Owner + SFTP only) -->
                  <tr *ngIf="authorization?.userAccount?.subscription?.plan?.isSftpUser === 'Y' && !isTeamMember"
                      data-testid="pref-email-sftp-transfer-team-job">
                    <th class="col-sm-1 col-xs-1" style="text-align: right; vertical-align: middle;">
                      <label class="switch">
                        <input type="checkbox" [(ngModel)]="preferences.emailSftpTransferTeamJob"
                               (ngModelChange)="onToggleChange()" name="emailSftpTransferTeamJob"/>
                        <span class="slider round"> </span>
                      </label>
                    </th>
                    <td class="col-sm-9 col-xs-9">
                      <strong translate>Successful SFTP transfer (team member's job)</strong><br>
                      <small class="text-muted" translate>Email sent when an SFTP transfer completes successfully for a document your team member sent</small>
                    </td>
                  </tr>

                  <!-- #9 Daily Digest Email -->
                  <tr data-testid="pref-email-daily-digest">
                    <th class="col-sm-1 col-xs-1" style="text-align: right; vertical-align: middle;">
                      <label class="switch">
                        <input type="checkbox" [(ngModel)]="preferences.emailDailyDigest"
                               (ngModelChange)="onToggleChange()" name="emailDailyDigest"/>
                        <span class="slider round"> </span>
                      </label>
                    </th>
                    <td class="col-sm-9 col-xs-9">
                      <strong translate>Daily Digest Email</strong><br>
                      <small class="text-muted" translate>Receive a daily summary of your signing activity</small>
                      <div *ngIf="preferences.emailDailyDigest" style="margin-top: 8px;">
                        <small class="text-muted" translate>Send at</small>&nbsp;
                        <select [(ngModel)]="preferences.dailyDigestHour"
                                (ngModelChange)="onToggleChange()" name="dailyDigestHour"
                                class="form-control" style="display: inline-block; width: auto; padding: 2px 8px; height: 28px; font-size: 13px;"
                                data-testid="daily-digest-hour-select">
                          <option *ngFor="let h of digestHourOptions" [ngValue]="h">
                            {{ h < 10 ? '0' + h : h }}:00
                          </option>
                        </select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- /Notification Preferences -->

        <div *ngIf="authorization?.userAccount?.subscription?.plan?.isSftpUser == 'Y' && isTeamMember == false" class="panel panel-default shadow" style="border: none">
          <div class="panel-heading">
            <h4 class="panel-title">{{translate.instant("Signed Document Targets")}}</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <table class="table table-sm table-xm table-condensed table-borderless">
                <thead></thead>
                <tbody>
                  <tr>
                    <th class="col-sm-2 col-xs-2" style="text-align: right"></th>
                    <td class="col-sm-8 col-xs-8">
                      <div class="row">
                        <div class="col-sm-6 col-xs-6">
                          {{translate.instant("SFTP Servers")}}
                        </div>
                        <div class="col-sm-6 col-xs-6">
                          <button type="button" class="btn btn-xs btn-primary" (click)="showAddSftpServer()" style="float: right;" translate>Add</button>
                        </div>
                      </div>
                    </td>
                    <td class="col-sm-2 col-xs-2"></td>
                  </tr>
                  <tr>
                    <td class="col-sm-2 col-xs-2"></td>
                    <td class="col-sm-8 col-xs-8">
                      <table class="table table-sm table-xm table-striped table-bordered">
                        <tr>
                          <th>{{translate.instant("Account Name")}}</th>
                          <th>{{translate.instant("Server Address")}}</th>
                          <th>{{translate.instant("Departments")}}</th>
                          <th>{{translate.instant("Actions")}}</th>
                        </tr>
                        <tr *ngFor="let sftpServer of sftpDetails; let i = index">
                          <td>{{sftpServer.serverName}}</td>
                          <td>{{sftpServer.serverAddress}}</td>
                          <td>{{sftpServer.departments}}</td>
                          <td>
                            <div style="width: 90px;">
                              <button type="button" class="btn btn-default btn-xs" (click)="showRemoveSftpAlert(sftpServer.serverName,sftpServer.id)"><i class="icon-trash"></i></button>
                              <button type="button" class="btn btn-default btn-xs" (click)="showEditSftpServer(i)"><i class="icon-gear"></i></button>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td class="col-sm-2 col-xs-2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="authorization?.userAccount?.subscription?.isApiUser=='YES'" class="panel panel-default shadow" style="border: none">
          <div class="panel-heading">
            <h4 class="panel-title" translate>API Key</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <form #f="ngForm">
                <table class="table table-sm table-xm table-condensed table-borderless">
                  <thead></thead>
                  <tbody>
                  <tr>
                    <th class="col-sm-2 col-xs-3" style="text-align: right" translate >Token Name</th>
                    <th class="col-sm-6 col-xs-7">
                      <div class="input-group">
                        <input type="text" class="form-control" [(ngModel)]="apiKey.tokenName" #tokenName name="tokenName" required >
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th class="col-sm-2 col-xs-3" style="text-align: right" translate >Key Expiry Date</th>
                    <td class="col-sm-6 col-xs-7">
                      <div class="input-group">
                        <input type="date" class="form-control" style="width: 200px;" [(ngModel)]="apiKey.expiresAt" #expiresAt name="expiresAt" required [min]="minApiKeyDate | date:'yyyy-MM-dd' " [max]="maxApiKeyDate | date:'yyyy-MM-dd'" >
                        <button type="button" class="btn btn-xs btn-primary" style="position: absolute; margin-left: 10px; margin-top: 2px;" [disabled]="!f.valid" (click)="generateApiKey(f)" translate>Generate</button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </form>
              <table class="table table-sm table-xm table-condensed table-borderless">
                <thead></thead>
                <tbody>
                  <tr>
                    <th class="col-sm-3 col-xs-3" style="text-align: right" translate>Key</th>
                    <td class="col-sm-6 col-xs-6">
                      <div class="form-group">
                        <div class="input-group">
                          <input type="text" class="form-control" [(ngModel)]="userCallback.key" #key name="key" readonly >
                          <span class="input-group-btn">
                            <button class="btn btn-default" type="button" [ngxClipboard]="key" [disabled]="!userCallback.key"  (cbOnSuccess)="notificationService?.apiKeyCopied()">
                              <span class="icon-copy3"></span> {{ 'COPY' | translate}}
                            </button>
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="col-sm-3 col-xs-3"></td>
                    <td class="col-sm-6 col-xs-6">
                      <table class="table table-sm table-xm table-condensed table-bordered">
                        <tr class="table-th">
                          <th translate>Token Name</th>
                          <th translate>Token ID</th>
                          <th translate>Key Expiry Date</th>
                          <th translate>Status</th>
                          <th></th>
                        </tr>
                        <tr *ngFor="let apiKeyElement of apiKeyArray">
                          <td>{{apiKeyElement.tokenName}}</td>
                          <td>{{apiKeyElement.tokenId}}</td>
                          <td>{{apiKeyElement.tokenExpire | date:'dd-MM-yyyy'}}</td>
                          <td style="text-align: center;">
                            <i *ngIf="+apiKeyElement.tokenExpire < today.getTime()" class="icon-alarm-cancel" style="font-size: 3rem; color: grey;" [title]="translate.instant('EXPIRED' | titlecase)"></i>
                            <i *ngIf="apiKeyElement.tokenStatus == 'ACTIVE' && +apiKeyElement.tokenExpire >= today.getTime()" class="icon-checkmark-circle" style="font-size: 3rem; color: green;" [title]="translate.instant(apiKeyElement.tokenStatus | titlecase)"></i>
                            <i *ngIf="apiKeyElement.tokenStatus == 'REVOKED' && +apiKeyElement.tokenExpire >= today.getTime()" class="icon-minus-circle2" style="font-size: 3rem; color: red;" [title]="translate.instant(apiKeyElement.tokenStatus | titlecase)" ></i>
                          </td>
                          <td>
                            <button type="button" class="btn btn-danger btn-xs" (click)="+apiKeyElement.tokenExpire < today.getTime() ? deleteExpiredApiKey(apiKeyElement.id) : revokeApiKey(apiKeyElement.id)" [disabled]="apiKeyElement.tokenStatus == 'REVOKED' && +apiKeyElement.tokenExpire > today.getTime()" ><i class="icon-trash"></i></button>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td class="col-sm-3 col-xs-3"></td>
                  </tr>
                  <tr>
                    <th></th>
                    <th><hr></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th class="col-sm-2 col-xs-3" style="text-align: right" translate>Callback Address After Signing</th>
                    <td class="col-sm-6 col-xs-7">
                      <input type="text" id="callbackURL" name="callbackURL" class="form-control" [(ngModel)]="userCallback.callbackURL" #callbackURL="ngModel">
                    </td>
                    <td class="col-sm-2 col-xs-2">
                      <button type="button" class="btn btn-xs btn-primary" (click)="saveCallbackURL()" [disabled]="!userCallback.callbackURL" translate>Save</button>
                    </td>
                  </tr>
                  <tr>
                    <th class="col-sm-2 col-xs-3" style="text-align: right" translate>Return URL After Signing</th>
                    <td class="col-sm-6 col-xs-7">
                      <input type="text" id="returnURL" name="returnURL" class="form-control" [(ngModel)]="userCallback.returnURL" #callbackURL="ngModel">
                    </td>
                    <td class="col-sm-2 col-xs-2">
                      <button type="button" class="btn btn-xs btn-primary" (click)="saveReturnURL()" [disabled]="!userCallback.returnURL" translate>Save</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="isTeamMember == false" class="panel panel-default shadow" [ngClass]="{'disabled':this.authorization.userAccount.subscription.plan.teamMembers == 0}" style="border: none">
          <div class="panel-heading">
            <h4 class="panel-title">{{translate.instant("Organization Management")}}</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <table class="table table-sm table-xm table-condensed table-borderless">
                <thead></thead>
                <tbody>
                  <tr>
                    <td class="col-sm-2 col-xs-2"></td>
                    <td class="col-sm-8 col-xs-8">
                      <p *ngIf="teamMemberQuota == 0">{{translate.instant("Your current plan is not suitable for team building. Please upgrade your plan.")}}</p>
                      <table class="table table-sm table-xm table-striped table-bordered">
                        <tr>
                          <th>{{translate.instant("Department Name")}}</th>
                          <th>{{translate.instant("Member Email")}}</th>
                          <th>{{translate.instant("Status")}}</th>
                          <th>{{translate.instant("Actions")}}</th>
                        </tr>
                        <tr *ngFor="let teamMember of teamMemberDetails; let i = index">
                          <td>{{teamMember.branch == null ? translate.instant("EMPTY") : teamMember.branch}}</td>
                          <td>{{teamMember.member == null ? translate.instant("EMPTY") : teamMember.member.email}}</td>
                          <td>{{teamMember.status == null ? translate.instant("EMPTY") : translate.instant(teamMember.status)}}</td>
                          <td>
                            <button *ngIf="teamMember.status == 'ACTIVE'" type="button" class="btn btn-danger btn-xs" (click)="showRemoveTeamMemberAlert(teamMember.member.email,teamMember.id)">{{translate.instant("Remove Access")}}</button>
                            <button *ngIf="teamMember.status == 'PENDING'" type="button" class="btn btn-warning btn-xs" (click)="showCancelTeamMemberRequestAlert(teamMember.member.email,teamMember.id)">{{translate.instant("Cancel Request")}}</button>
                            <button *ngIf="teamMember.status == null" type="button" class="btn btn-success btn-xs" (click)="showAddNewTeamMember()">{{translate.instant("Give Access")}}</button>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td class="col-sm-2 col-xs-2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div *ngIf="isTeamMember != false" class="panel panel-default shadow" style="border: none">
          <div class="panel-heading">
            <h4 class="panel-title">{{translate.instant("Organization Management Actions")}}</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <table class="table table-sm table-xm table-condensed table-borderless">
                <thead></thead>
                <tbody>
                  <tr>
                    <td class="col-sm-2 col-xs-2"></td>
                    <td class="col-sm-8 col-xs-8">{{translate.instant("Transfer the documents I had before to the organization owner.")}}</td>
                    <td class="col-sm-2 col-xs-2">
                      <button type="button" class="btn btn-primary btn-xs" (click)="transferFilesAlert()" >{{translate.instant("Transfer Files")}}</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div *ngIf="isTeamMember == false" class="panel panel-default shadow" style="border: none">
          <div class="panel-heading">
            <h4 class="panel-title" translate>Account deletion</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <table class="table table-sm table-xm table-condensed table-borderless">
                <thead></thead>
                <tbody>
                  <tr>
                    <td class="col-sm-8 col-xs-8" translate>DELETE_ACCOUNT_ACCOUNT_PAGE_POINTER</td>
                    <td class="col-sm-4 col-xs-4 text-right">
                      <button id="accountDeletionLink" type="button" class="btn btn-xs btn-with btn-primary"
                              (click)="showSubscriptionInfo()" translate>Account deletion</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      <!-- </div>
    </div>-->
  </div>
</div>


<!-- modal update profile -->
<div id="modalUpdateProfile" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h6 class="modal-title" translate>Update Profile</h6>
      </div>
      <div class="modal-body">
        <div class="row col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
          <!--<form>-->
          <form #f="ngForm" novalidate>
            <div class="form-group form-group-material">
              <label for="name" class="control-label" [ngClass]="getClasses(name.value)"><strong translate>Name</strong></label>
              <input type="text" id="name" name="name" class="form-control" placeholder="{{translate.instant('Name')}}" [(ngModel)]="userMetadata.name" #name="ngModel" required pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .]*)$">
              <!--show error only when field is not valid & it's dirty or form submited-->
              <small [hidden]="name.valid || (name.pristine && !f.submitted)" class="text-danger" translate>Name is required.</small>
            </div>
            <div class="form-group form-group-material">
              <label for="title" class="control-label" [ngClass]="getClasses(title.value)"><strong translate>Title</strong></label>
              <input type="text" id="title" name="title" class="form-control" placeholder="{{translate.instant('Title')}}" [(ngModel)]="userMetadata.title" #title="ngModel" maxlength="30" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .,]*)$">
              <!--show error only when field is not valid & it's dirty or form submited-->
              <small [hidden]="title.valid || (title.pristine && !f.submitted)" class="text-danger" translate>Title is optional.</small>
            </div>
            <div class="form-group form-group-material">
              <label for="company" class="control-label" [ngClass]="getClasses(company.value)"><strong translate>Company</strong></label>
              <input type="text" id="company" name="company" class="form-control" placeholder="{{translate.instant('Company')}}" [(ngModel)]="userMetadata.company" #company="ngModel" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .]*)$">
              <!--show error only when field is not valid & it's dirty or form submited-->
              <small [hidden]="company.valid || (company.pristine && !f.submitted)" class="text-danger" translate>Company is optional.</small>
            </div>
            <div class="form-group form-group-material">
              <label for="address" class="control-label" [ngClass]="getClasses(address.value)"><strong translate>Address</strong></label>
              <input type="text" id="address" name="address" class="form-control" placeholder="{{translate.instant('Address')}}" [(ngModel)]="userMetadata.address" #address="ngModel" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ0-9 '-.,:/]*)$">
              <!--show error only when field is not valid & it's dirty or form submited-->
              <small [hidden]="address.valid || (address.pristine && !f.submitted)" class="text-danger" translate>Address is optional.</small>
            </div>
            <div class="form-group">
              <label><strong translate>Country</strong></label>
              <select name="country" class="form-control" [(ngModel)]="userMetadata.country" [value]="userMetadata.country">
                <option *ngFor="let country of countries" [value]="country.isoCode" translate>{{country.countryName}}</option>
              </select>
            </div>
            <div class="form-group">
              <label><strong translate>Language</strong></label>
              <select name="language" class="form-control" [(ngModel)]="userMetadata.language">
                <option *ngFor="let language  of languages" [value]="language.value">{{language.display | translate}}</option>
              </select>
            </div>
            <br>
            <hr>
            <div class="row text-right">
              <div class="col-md-11 col-sm-11 col-xs-11">
                <button type="button" class="btn btn-link" (click)="f.reset();" data-dismiss="modal" translate>Cancel</button>
                <button type="button" class="btn btn-xs btn-primary pull-right" (click)="UpdateProfile(f.value); f.reset()" [disabled]="!f.valid" translate>Save</button>
              </div>
            </div>

          </form>
          <!--</form>-->
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->

<!--Account ADD Email-->
<div id="addNewEmail" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Add New Email</h5>
      </div>
      <form #form="ngForm" novalidate>
        <div class="modal-body">
          <div class="row col-sm-10 col-sm-offset-1">
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right "><strong translate>Email:</strong></label>
              <div class="col-sm-8 col-xs-8 text-left">
                <input type="email" class="form-control" [ngClass]="{'error':!newEmail.valid && newEmail.touched}" [(ngModel)]="associatedEmail" placeholder="{{translate.instant('Email Address')}}" name="newEmail" #newEmail="ngModel" required minlength="5" pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$">
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
          <button class="btn btn-primary" type="button" (click)="addEmail()" [disabled]="!form.valid" translate>Add</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!--Account ADD Email-->

<!--Account ADD SFTP Server-->
<div id="addNewSftpServer" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Add New SFTP Server</h5>
      </div>
      <form #formAddSftp="ngForm" (ngSubmit)="addSftpServer(formAddSftp)">
        <div class="modal-body">
          <div class="row col-sm-10 col-sm-offset-1">
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Name")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="text" class="form-control" [placeholder]="translate.instant('bank_sftp')" ngModel maxlength="49" id="sftpName" name="sftpName" [(ngModel)]="addSftpNameInput" required>
                <!-- <label style="color: red;" [hidden]="formAddSftp.value.sftpName != null && formAddSftp.value.sftpName != ''" >{{translate.instant("Server name can't be empty.")}}</label> -->
              </div>
            </div>
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Server")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="text" class="form-control" [placeholder]="translate.instant('sftp.server.com')" ngModel maxlength="79"  id="sftpServer" name="sftpServer" [(ngModel)]="addSftpServerInput" required>
                <!-- <label style="color: red;" [hidden]="formAddSftp.value.sftpServer != null && formAddSftp.value.sftpServer != ''" >{{translate.instant("Server address can't be empty.")}}</label> -->
                <label style="color: red;" [hidden]="addSftpServerInput != null ? !addSftpServerInput.includes(' ') : true" >{{translate.instant("Server address is not valid.")}}</label>
              </div>
              <label class="col-sm-1 col-xs-1 text-right"><strong>{{translate.instant("Port")}}</strong></label>
              <div class="col-sm-2 col-xs-2 text-left">
                <input type="number" class="form-control" placeholder="22" value="22" pattern=".{0,5}" id="sftpPort" name="sftpPort" ngModel [(ngModel)]="addSftpPortInput" required>
              </div>
            </div>
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Username")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="text" class="form-control" [placeholder]="translate.instant('user')" ngModel maxlength="49" id="sftpUsername" name="sftpUsername" [(ngModel)]="addSftpUsernameInput" required>
                <!-- <label style="color: red;" [hidden]="formAddSftp.value.sftpUsername != null && formAddSftp.value.sftpUsername != ''" >{{translate.instant("Username can't be empty.")}}</label> -->
              </div>
            </div>
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Password")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="password" class="form-control" maxlength="49" ngModel [placeholder]="translate.instant('Password')" id="sftpPassword" name="sftpPassword" [(ngModel)]="addSftpPasswordInput" required>
                <!-- <label style="color: red;" [hidden]="formAddSftp.value.sftpPassword != null && formAddSftp.value.sftpPassword != ''" >{{translate.instant("Password can't be empty.")}}</label> -->
              </div>
            </div>
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Directory")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="text" class="form-control" maxlength="49" ngModel [placeholder]="translate.instant('/directory')" id="sftpDirectory" name="sftpDirectory" [(ngModel)]="addSftpDirectoryInput">
              </div>
            </div>
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Departments")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="text" class="form-control" maxlength="49" ngModel [placeholder]="translate.instant('departments')" id="sftpDepartments" name="sftpDepartments" [(ngModel)]="addSftpDepartmentsInput">
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-link" type="button" data-dismiss="modal" translate (click)="onAddServerCancelButtonClicked()">Cancel</button>
          <button class="btn btn-primary" type="submit" [disabled]="formAddSftp.invalid || (addSftpServerInput != null ? addSftpServerInput.includes(' ') : false)" translate>Add</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!--Account ADD SFTP Server-->

<!--Account EDIT SFTP Server-->
<div id="editSftpServer" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" id="updateSftpTitle"></h5>
      </div>
      <form #formUpdateSftp="ngForm" (ngSubmit)="editSftpServer(formUpdateSftp)">
        <div class="modal-body">
          <div class="row col-sm-10 col-sm-offset-1">
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Name")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="text" class="form-control" [placeholder]="translate.instant('bank_sftp')" maxlength="49" id="updateSftpName" name="updateSftpName" [(ngModel)]="updateSftpNameInput" ngModel required>
                <!-- <label style="color: red;" [hidden]="formUpdateSftp.value.updateSftpName != null && formUpdateSftp.value.updateSftpName != ''" >{{translate.instant("Server name can't be empty.")}}</label> -->
              </div>
            </div>
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Server")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="text" class="form-control" [placeholder]="translate.instant('sftp.server.com')" maxlength="79" id="updateSftpServer" name="updateSftpServer" [(ngModel)]="updateSftpServerInput" ngModel required>
                <!-- <label style="color: red;" [hidden]="formUpdateSftp.value.updateSftpServer  != null && formUpdateSftp.value.updateSftpServer  != ''" >{{translate.instant("Server address can't be empty.")}}</label> -->
                <label style="color: red;" [hidden]="updateSftpServerInput != null ? !updateSftpServerInput.includes(' ') : true" >{{translate.instant("Server address is not valid.")}}</label>
              </div>
              <label class="col-sm-1 col-xs-1 text-right"><strong>{{translate.instant("Port")}}</strong></label>
              <div class="col-sm-2 col-xs-2 text-left">
                <input type="number" class="form-control" placeholder="22" id="updateSftpPort" name="updateSftpPort" [(ngModel)]="updateSftpPortInput" ngModel required>
                <!-- <label style="color: red;" [hidden]="formUpdateSftp.value.updateSftpPort != null && formUpdateSftp.value.updateSftpPort  != ''" >{{translate.instant("Server Port can't be empty.")}}</label> -->
              </div>
            </div>
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Username")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="text" class="form-control" [placeholder]="translate.instant('user')" maxlength="49" id="updateSftpUsername" name="updateSftpUsername" [(ngModel)]="updateSftpUsernameInput" ngModel required>
                <!-- <label style="color: red;" [hidden]="formUpdateSftp.value.updateSftpUsername != null && formUpdateSftp.value.updateSftpUsername != ''" >{{translate.instant("Username can't be empty.")}}</label> -->
              </div>
            </div>
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Password")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="password" class="form-control" #updateSftpPassword id="updateSftpPassword" name="updateSftpPassword" [(ngModel)]="updateSftpPasswordInput" ngModel maxlength="49" required>
                <!-- <label style="color: red;" [hidden]="formUpdateSftp.value.updateSftpPassword != null && formUpdateSftp.value.updateSftpPassword != ''" >{{translate.instant("Password can't be empty.")}}</label> -->
              </div>
            </div>
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Directory")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="text" class="form-control" maxlength="49" [placeholder]="translate.instant('/directory')" id="updateSftpDirectory" name="updateSftpDirectory" [(ngModel)]="updateSftpDirectoryInput" ngModel>
              </div>
            </div>
            <div class="form-group position position">
              <label class="col-sm-2 col-xs-2 text-right"><strong>{{translate.instant("Departments")}}</strong></label>
              <div class="col-sm-7 col-xs-7 text-left">
                <input type="text" class="form-control" maxlength="49" [placeholder]="translate.instant('departments')" id="updateSftpDepartments" name="updateSftpDepartments" [(ngModel)]="updateSftpDepartmentsInput" ngModel>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
          <button class="btn btn-primary" type="submit" [disabled]="formUpdateSftp.invalid || (updateSftpServerInput != null ? updateSftpServerInput.includes(' ') : false)" translate>Update</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!--Account EDIT SFTP Server-->

<!--Account ADD Team Member -->
<div id="addNewTeamMember" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>{{translate.instant("Add Team Member")}}</h5>
      </div>
      <form #addTeamMemberForm="ngForm" (ngSubmit)="addTeamMember()">
        <div class="modal-body">
          <div class="row col-sm-10 col-sm-offset-1">
            <div class="form-group position position">
              <label class="col-sm-3 col-xs-3 text-left "><strong>{{translate.instant("Department")}}: </strong></label>
              <div class="col-sm-8 col-xs-8 text-left">
                <input type="text" class="form-control" placeholder="{{translate.instant('Department Name')}}" name="newTeamMemberDepartment" id="newTeamMemberDepartment" [(ngModel)]="addNewTeamMemberDepartmentInput" ngModel required>
              </div>
              <div class="col-sm-1 col-xs-1 text-left"></div>
            </div>
            <div class="form-group position position">
              <label class="col-sm-3 col-xs-3 text-left "><strong>{{"Email" | translate}}: </strong></label>
              <div class="col-sm-8 col-xs-8 text-left">
                <input type="email" class="form-control" placeholder="{{translate.instant('Email')}}" name="newTeamMemberEmail" id="newTeamMemberEmail" [(ngModel)]="addNewTeamMemberEmailInput" ngModel required minlength="5" pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$">
              </div>
              <div class="col-sm-1 col-xs-1 text-left"></div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
          <button class="btn btn-primary" type="submit" [disabled]="addTeamMemberForm.invalid">{{translate.instant("Invite")}}</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!--Account ADD Team Member -->

<!--Account REMOVE Team Member -->
<div id="removeNewTeamMember" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Remove Access</h5>
      </div>
      <form #removeTeamMemberForm="ngForm" (ngSubmit)="deleteTeamMember()">
        <div class="modal-body">
          <div class="row col-sm-12">
            <div class="form-group position position">
              <div class="col-sm-12 col-xs-12 text-left ">
                <ng-container *ngIf="userMetadata.language == 'tr'">
                  <b>{{removedTeamMemberEmail}}</b> eposta adresine sahip olan kişi organizasyondan çıkarılacaktır ve erişimi kaldırılacaktır.
                </ng-container>
                <ng-container *ngIf="userMetadata.language == 'en'">
                  The person with the <b>{{removedTeamMemberEmail}}</b> email address will be removed from the organization and their access will be removed.
                </ng-container>
                <br><br>
                {{translate.instant("Documents owned by this person will be transferred to another person in the organization.")}}
                <br><br>
                <strong>{{translate.instant("This action is irreversible!")}}</strong>
                <br><br>
                {{translate.instant("Please contact the support team for information.")}}
                <br><br>
                <ng-container *ngIf="userMetadata.language == 'tr'">
                  <b>{{removedTeamMemberEmail}}</b> kullanıcısının belgelerinin aktarılacağı organizasyon üyesini seçiniz:
                </ng-container>
                <ng-container *ngIf="userMetadata.language == 'en'">
                  Select the organization member to whom the documents of the <b>{{removedTeamMemberEmail}}</b> user will be transferred:
                </ng-container>
              </div>
            </div>
            <div class="form-group position position">
              <div class="col-sm-12 col-xs-12 text-left">
                <select style="font-size:16px" id="assignMemberDropdown">
                  <option value="0"> {{authorization?.userProfile?.user_metadata?.name}} ({{theAccountEmails[0] == null ? "" : theAccountEmails[0].email}}) - {{translate.instant("Organization Owner")}}</option>
                  <ng-container *ngFor="let teamMember of teamMemberDetails; let i = index">
                    <ng-container *ngIf="teamMember.id != null && teamMember.id != removedTeamMemberID">
                      <option value="{{teamMember.id}}"> {{teamMember.member.name}} ({{teamMember.member.email}}) - {{teamMember.branch}}</option>
                    </ng-container>
                  </ng-container>
                </select>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-link" type="button" data-dismiss="modal" translate>Cancel</button>
          <button class="btn btn-primary" type="submit">{{translate.instant("Remove Member Access")}}</button>
        </div>
      </form>
    </div>
  </div>
</div>
